import httpRequest from '@/utils/httpRequest'
import config from '@/config/url.config';
import axios from 'axios'
import qs from 'qs'
export const getScroll = function (data) {
  //首页-获取轮播图列表
  return httpRequest({
    url: config.scroll,
    method: 'GET',
    params: data
  });
};

export const delScrool = function (data) {
  //首页-删除轮播图
  return httpRequest({
    url: config.delScrool,
    method: 'POST',
    data: qs.stringify(data),
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
  });
};
export const productListApi = function (data) {
  //首页-获取产品体系列表
  return httpRequest({
    url: config.productList,
    method: 'GET',
    params: data
  });
};
export const uploadViewPaper = function (data) {
  //首页-上传轮播图
  return httpRequest({
    url: config.uploadViewPaper,
    method: 'POST',
    data: data,
    headers: {
      'Content-Type': 'multipart/form-data'
    },
  });
};
export const uploadHonorPic = function (data) {
  //首页-上传轮播图
  return httpRequest({
    url: config.uploadHonorPic,
    method: 'POST',
    data: data,
    headers: {
      'Content-Type': 'multipart/form-data'
    },
  });
};

export const sortHonorPic = function (data) {
  //荣誉资质图排序
  return httpRequest({
    url: config.sortHonorPic,
    method: 'POST',
    data: qs.stringify(data),
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
  });
};
export const delSysProduct = function (data) {
  //产品体系-（批量）删除产品体系
  return httpRequest({
    url: config.delSysProduct,
    method: 'POST',
    data: qs.stringify(data),
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
  });
};
export const addSysProduct = function (data) {
  //产品体系-添加产品体系
  return httpRequest({
    url: config.addSysProduct,
    method: 'POST',
    data: qs.stringify(data),
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
  });
};
export const editSysProduct = function (data) {
  //产品体系-添加产品体系
  return httpRequest({
    url: config.editSysProduct,
    method: 'POST',
    data: qs.stringify(data),
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
  });
};
export const getNewsList = function (data) {
  //首页-获取首页公司新闻列表
  return httpRequest({
    url: config.getNewsList,
    method: 'GET',
    params: data
  });
};
export const addSysNews = function (data) {
  //产品体系-添加产品体系
  return httpRequest({
    url: config.addSysNews,
    method: 'POST',
    data: qs.stringify(data),
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
  });
};
export const editSysNews = function (data) {
  //新闻中心-编辑新闻或行业动态
  return httpRequest({
    url: config.editSysNews,
    method: 'POST',
    data: qs.stringify(data),
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
  });
};
export const delSysNews = function (data) {
  //新闻中心-（批量）删除新闻或行业动态
  return httpRequest({
    url: config.delSysNews,
    method: 'POST',
    data: qs.stringify(data),
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
  });
};
export const getBusinessList = function (data) {
  //首页-获取首页行业应用列表
  return httpRequest({
    url: config.getBusinessList,
    method: 'GET',
    params: data
  });
};
export const getSysNews = function (data) {
  //新闻中心-获取公司新闻或行业动态列表
  return httpRequest({
    url: config.getSysNews,
    method: 'GET',
    params: data
  });
};
export const uploadIllustration = function (data) {
  //通用-上传文本插图
  return httpRequest({
    url: config.uploadIllustration,
    method: 'POST',
    data: data,
    headers: {
      'Content-Type': 'multipart/form-data'
    },
  });
};
export const uploadIllustrationVideo = function (data) {
  //通用-上传文本插图
  // return httpRequest({
  //   url: config.uploadIllustration,
  //   method: 'POST',
  //   data: data,
  //   headers: {
  //     'Content-Type': 'multipart/form-data'
  //   },
  // });
   return axios.post(config.baseURL+config.uploadIllustration,data,{timeout:300000,ContentType: 'multipart/form-data'})
};
export const addBusiness = function (data) {
  //行业应用-添加行业
  return httpRequest({
    url: config.addBusiness,
    method: 'POST',
    data: qs.stringify(data),
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
  });
};
export const editBusiness = function (data) {
  //行业应用-编辑行业
  return httpRequest({
    url: config.editBusiness,
    method: 'POST',
    data: qs.stringify(data),
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
  });
};
export const delBusiness = function (data) {
  //行业应用-删除行业
  return httpRequest({
    url: config.delBusiness,
    method: 'POST',
    data: qs.stringify(data),
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
  });
};
export const getRecruitList = function (data) {
  //人才招聘-人才招聘-获取招聘信息列表
  return httpRequest({
    url: config.getRecruitList,
    method: 'GET',
    params: data
  });
};
export const addRecruit = function (data) {
  //人才招聘-人才招聘-添加招聘信息
  return httpRequest({
    url: config.addRecruit,
    method: 'POST',
    data: qs.stringify(data),
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
  });
};
export const editRecruit = function (data) {
  //人才招聘-人才招聘-编辑招聘信息
  return httpRequest({
    url: config.editRecruit,
    method: 'POST',
    data: qs.stringify(data),
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
  });
};
export const delRecruit = function (data) {
  //人才招聘-人才招聘-编辑招聘信息
  return httpRequest({
    url: config.delRecruit,
    method: 'POST',
    data: qs.stringify(data),
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
  });
};
export const getSysTrain = function (data) {
  //人才招聘-培训发展-获取
  return httpRequest({
    url: config.getSysTrain,
    method: 'GET',
    params: data
  });
};
export const addSysTrain = function (data) {
  //人才招聘-培训发展-添加
  return httpRequest({
    url: config.addSysTrain,
    method: 'POST',
    data: qs.stringify(data),
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
  });
};
export const editSysTrain = function (data) {
  //人才招聘-培训发展-编辑
  return httpRequest({
    url: config.editSysTrain,
    method: 'POST',
    data: qs.stringify(data),
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
  });
};
export const delSysTrain = function (data) {
  //人才招聘-培训发展-删除
  return httpRequest({
    url: config.delSysTrain,
    method: 'POST',
    data: qs.stringify(data),
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
  });
};
export const getIndustry = function (data) {
  //行业应用-获取行业应用
  return httpRequest({
    url: config.getIndustry,
    method: 'GET',
    params: data
  });
};
export const addIndustry = function (data) {
  //行业应用-新增行业应用
  return httpRequest({
    url: config.addIndustry,
    method: 'POST',
    data: qs.stringify(data),
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
  });
};
export const editIndustry = function (data) {
  //行业应用-编辑行业应用
  return httpRequest({
    url: config.editIndustry,
    method: 'POST',
    data: qs.stringify(data),
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
  });
};
export const delIndustry = function (data) {
  //行业应用-删除行业应用
  return httpRequest({
    url: config.delIndustry,
    method: 'POST',
    data: qs.stringify(data),
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
  });
};

export const getCompanyInfo = function (data) {
  //公司信息-获取公司信息
  return httpRequest({
    url: config.getCompanyInfo,
    method: 'GET',
    params: data
  });
};
export const addCompanyInfo = function (data) {
  //公司信息-添加公司信息
  return httpRequest({
    url: config.addCompanyInfo,
    method: 'POST',
    data: qs.stringify(data),
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
  });
};
export const editCompanyInfo = function (data) {
  //公司信息-编辑公司信息
  return httpRequest({
    url: config.editCompanyInfo,
    method: 'POST',
    data: qs.stringify(data),
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
  });
};
export const getCompanyIntro = function (data) {
  //关于我们-获取公司简介、企业文化
  return httpRequest({
    url: config.getCompanyIntro,
    method: 'GET',
    params: data
  });
};
export const addCompanyIntro = function (data) {
  //关于我们-添加公司简介、企业文化
  return httpRequest({
    url: config.addCompanyIntro,
    method: 'POST',
    data: qs.stringify(data),
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
  });
};
export const editCompnayIntro = function (data) {
  //关于我们-编辑公司简介、企业文化
  return httpRequest({
    url: config.editCompnayIntro,
    method: 'POST',
    data: qs.stringify(data),
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
  });
};
export const getHonorPic = function (data) {
  //关于我们-获取荣誉资质图
  return httpRequest({
    url: config.getHonorPic,
    method: 'GET',
    params: data
  });
};
export const addHonorPic = function (data) {
  //关于我们-添加荣誉资质图
  return httpRequest({
    url: config.addHonorPic,
    method: 'POST',
    data: qs.stringify(data),
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
  });
};
export const delHonorPic = function (data) {
  //关于我们-删除荣誉资质图
  return httpRequest({
    url: config.delHonorPic,
    method: 'POST',
    data: qs.stringify(data),
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
  });
};
export const sendInfoToCompany = function (data) {
  //联系我们
  return httpRequest({
    url: config.sendInfoToCompany,
    method: 'POST',
    data: qs.stringify(data),
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
  });
};
export const editHonorPic = function (data) {
  //编辑荣誉资质图
  return httpRequest({
    url: config.editHonorPic,
    method: 'POST',
    data: qs.stringify(data),
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
  });
};

export const editIcon = function (data) {
  //编辑产品体系的插图
  return httpRequest({
    url: config.editIcon,
    method: 'POST',
    data: qs.stringify(data),
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
  });
};

export const listProductType = function (data) {
  //体系类别-获取列表
  return httpRequest({
    url: config.listProductType,
    method: 'GET',
    params: data
  });
};

export const editProductType = function (data) {
  //体系类别-修改
  return httpRequest({
    url: config.editProductType,
    method: 'POST',
    data: qs.stringify(data),
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
  });
};
export const addProductType = function (data) {
  //体系类别-添加
  return httpRequest({
    url: config.addProductType,
    method: 'POST',
    data: qs.stringify(data),
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
  });
};
export const delProductType = function (data) {
  //体系类别-删除
  return httpRequest({
    url: config.delProductType,
    method: 'POST',
    data: qs.stringify(data),
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
  });
};